export default __webpack_public_path__ + "static/media/98-08_header_invoice.7cd92fc5.png";